import { render, staticRenderFns } from "./ServerDetails.vue?vue&type=template&id=6a7c326a&"
import script from "./ServerDetails.vue?vue&type=script&lang=js&"
export * from "./ServerDetails.vue?vue&type=script&lang=js&"
import style0 from "./ServerDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports